import { defineAction } from '~/prix'
import { z } from 'zod'
import { roadMaintenanceImageStatus } from '../roadMaintenanceImageObject'
import roadMaintenanceImageConfirmAction from './roadMaintenanceImageConfirm.action.json' with { type: 'json' }

const roadMaintenanceImageConfirmDefinition = defineAction({
  ...roadMaintenanceImageConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: roadMaintenanceImageStatus,
  }),
  output: z.object({}),
})

export default roadMaintenanceImageConfirmDefinition
